import {FormControlLabel, withStyles} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import * as React from "react";
import {AonColors, LegacyColors} from "../../../../css/Colors";

export interface ICheckBoxProps {
    name: string;
    checked: boolean;
    onChange: () => void;
    label: string;
}

export const CheckBoxComponent: React.FunctionComponent<ICheckBoxProps> = (props) => {
    const styles = {
        root: {
            color: LegacyColors.Black54,
        },
        checked: {
            "&$checked": {
                color: AonColors.AonTealDark,
            },
        },
    };

    const CustomCheckBox = withStyles(styles)(Checkbox);
    return <FormControlLabel
        key={props.name}
        control={
            <CustomCheckBox
                color="primary"
                className={`shared-components__${props.name}-checkbox`}
                checked={props.checked}
                key={props.name}
                onChange={() => props.onChange()}
            />
        }
        label={<div className="shared-components_checkbox-label">{props.label}</div>}
    />;
};
